<template>
  <div class="tabs">
    <input type="radio" id="tab1" name="tab-control" checked />
    <input type="radio" id="tab2" name="tab-control" />
    <input type="radio" id="tab3" name="tab-control" />
    <input type="radio" id="tab4" name="tab-control" />
    <input type="radio" id="tab5" name="tab-control" />
    <input type="radio" id="tab6" name="tab-control" />

    <ul>
      <li :title="$t('details')">
        <label for="tab1" role="button" style="font-size: 1.8em;">
          <svg viewBox="0 0 24 24">
            <path
              d="M20.93,7.79H15.19a.67.67,0,0,0,0,1.33h5.74a.67.67,0,1,0,0-1.33Z"
              transform="translate(-0.4 -0.29)"
            />
            <path
              d="M20.93,10.44H15.19a.67.67,0,0,0,0,1.33h5.74a.67.67,0,1,0,0-1.33Z"
              transform="translate(-0.4 -0.29)"
            />
            <path
              d="M20.93,13.09H15.19a.66.66,0,1,0,0,1.32h5.74a.66.66,0,1,0,0-1.32Z"
              transform="translate(-0.4 -0.29)"
            />
            <path
              d="M20.93,15.74H15.19a.66.66,0,1,0,0,1.32h5.74a.66.66,0,1,0,0-1.32Z"
              transform="translate(-0.4 -0.29)"
            />
            <path
              d="M20.93,18.39H15.19a.66.66,0,0,0,0,1.32h5.74a.66.66,0,1,0,0-1.32Z"
              transform="translate(-0.4 -0.29)"
            />
            <path
              d="M11.22,7.79H2A1.56,1.56,0,0,0,.4,9.34v8.83A1.55,1.55,0,0,0,2,19.71h9.27a1.55,1.55,0,0,0,1.55-1.54V9.34a1.56,1.56,0,0,0-1.55-1.55ZM6.58,10.88a1.33,1.33,0,1,1-1.32,1.33A1.32,1.32,0,0,1,6.58,10.88ZM9.23,16.4a.67.67,0,0,1-.66.66h-4a.67.67,0,0,1-.66-.66v-.33a1.77,1.77,0,0,1,1.85-1.66H7.38a1.77,1.77,0,0,1,1.85,1.66Z"
              transform="translate(-0.4 -0.29)"
            />
            <path
              d="M20.05.29H2A1.55,1.55,0,0,0,.4,1.83V4A1.56,1.56,0,0,0,2,5.59h18.1A1.56,1.56,0,0,0,21.6,4V1.83A1.55,1.55,0,0,0,20.05.29Z"
              transform="translate(-0.4 -0.29)"
            />
          </svg>
          <br />
          <span>{{ $t('details') }}</span>
        </label>
      </li>
      <li :title="$tc('contact', 2)">
        <label for="tab2" role="button" style="font-size: 1.8em;">
          <svg viewBox="0 0 24 24">
            <path
              d="M17.6,2.3,18.4.77a.53.53,0,0,0,0-.52A.55.55,0,0,0,17.94,0H4a.52.52,0,0,0-.53.52V20h15V4.11ZM14.86,15.58a1.84,1.84,0,0,1-1.87.11h0A12.57,12.57,0,0,1,9.4,13.21h0A13.16,13.16,0,0,1,6.91,9.62h0A1.87,1.87,0,0,1,7,7.74a2.11,2.11,0,0,1,1.52-.88A.4.4,0,0,1,8.74,7l0,0L10.5,9.07a.33.33,0,0,1,.07.26,1.63,1.63,0,0,1-.45.86l-.11.12a1.64,1.64,0,0,1-.37.28l-.13.08.09.12A9.28,9.28,0,0,0,11.81,13l.12.09L12,13a1.76,1.76,0,0,1,.29-.37l.12-.11a1.63,1.63,0,0,1,.86-.45.35.35,0,0,1,.26.07l2.09,1.74a.3.3,0,0,1,.11.23A2.08,2.08,0,0,1,14.86,15.58ZM4.54,4.08v-3H17.07l-.53,1a.53.53,0,0,0,0,.49l.8,1.54Z"
              transform="translate(-3.49)"
            />
          </svg>
          <br />
          <span>{{ $tc('contact', 2) }}</span>
        </label>
      </li>
      <li :title="$tc('account', 3)">
        <label for="tab3" role="button" style="font-size: 1.8em;">
          <svg viewBox="0 0 24 24">
            <path
              d="M9.67,6V4.67h-8A1.34,1.34,0,0,0,.34,6V8.67H10A11.7,11.7,0,0,1,9.67,6Z"
              transform="translate(-0.34 -0.67)"
            />
            <path
              d="M21.6,11.33a11.91,11.91,0,0,1-4.27,3.73,2,2,0,0,1-1,.27,2,2,0,0,1-1-.26,12.06,12.06,0,0,1-4.28-3.74H.34V18a1.34,1.34,0,0,0,1.33,1.34H20.33A1.34,1.34,0,0,0,21.66,18V11.33Zm-15.26,4H3.67a.67.67,0,0,1,0-1.33H6.34a.67.67,0,0,1,0,1.33Z"
              transform="translate(-0.34 -0.67)"
            />
            <path
              d="M21.26,2.73l-4.67-2a.67.67,0,0,0-.52,0l-4.67,2a.66.66,0,0,0-.4.61V6c0,3.67,1.35,5.81,5,7.91a.65.65,0,0,0,.66,0c3.64-2.09,5-4.24,5-7.91V3.34A.66.66,0,0,0,21.26,2.73Zm-2.41,3L16.18,9.08a.65.65,0,0,1-.52.25h0A.68.68,0,0,1,15.11,9L13.78,7a.67.67,0,0,1,1.11-.74l.82,1.24,2.1-2.62a.67.67,0,0,1,.93-.1A.66.66,0,0,1,18.85,5.75Z"
              transform="translate(-0.34 -0.67)"
            />
          </svg>
          <br />
          <span>{{ $tc('account', 3) }}</span>
        </label>
      </li>
      <li :title="$t('taxVerification')">
        <label for="tab4" role="button" style="font-size: 1.8em;">
          <svg viewBox="0 0 423 511.82" fill-rule="evenodd" clip-rule="evenodd">
            <path
              d="M330.55 326.9c51.05 0 92.45 41.41 92.45 92.46s-41.4 92.46-92.45 92.46c-51.06 0-92.46-41.41-92.46-92.46s41.4-92.46 92.46-92.46zm62.86-303.66C393.41 10.46 382.93 0 370.16 0H23.25C10.46 0 0 10.47 0 23.24v430.29c0 12.78 10.46 23.25 23.25 23.25h203.21c-2.92-5.26-5.44-10.77-7.55-16.48H19.38c-1.28 0-2.44-1.13-2.44-2.44V21.07c0-1.32 1.16-2.44 2.44-2.44h355.28c1.3 0 2.44 1.19 2.44 2.44v288.92c5.67 2.43 11.12 5.29 16.31 8.53V23.24zM59.58 57.44h12.9v53.98h-12.9V57.44zm23.74 0h12.01l15.6 29.81V57.44h12.16v53.98h-12.16L95.42 81.78v29.64h-12.1V57.44zm45.78 0h13.43l9.38 38.85 9.24-38.85h13.05l-15.45 53.98h-13.93L129.1 57.44zm52.88 6.46c7.57-9.8 24.18-9.96 31.83-.13 6.65 8.54 7.16 25.92 3.17 35.76-1.64 4.03-4.02 7.18-7.11 9.42-6.12 4.46-16.89 4.46-23.22.47-3.08-1.94-5.58-5.01-7.49-9.21-4.53-9.96-3.96-27.52 2.82-36.31zm9.51 32.34c3.08 4.69 9.72 4.84 12.82.08 3.07-4.73 3.15-18.85-.1-23.67-3.19-4.72-9.56-4.69-12.71.05-3.19 4.84-3.2 18.7-.01 23.54zm36.91-38.8h12.91v53.98H228.4V57.44zm51.36 31.9 11.27 4.4c-.75 4.09-1.95 7.53-3.58 10.27-1.63 2.74-3.65 4.82-6.06 6.22-2.41 1.38-5.49 2.1-9.22 2.1-4.53 0-8.23-.85-11.1-2.56-2.87-1.7-5.35-4.71-7.42-8.99-2.08-4.28-3.13-9.79-3.13-16.47 0-8.92 1.83-15.79 5.5-20.58 3.66-4.79 8.85-7.19 15.55-7.19 5.25 0 9.38 1.38 12.38 4.12 2.98 2.75 5.22 6.97 6.68 12.68L279.3 76.6c-.4-1.64-.82-2.84-1.25-3.59-.73-1.26-1.61-2.24-2.65-2.92a6.297 6.297 0 0 0-3.49-1.04c-2.93 0-5.16 1.54-6.72 4.56-1.16 2.25-1.77 5.79-1.77 10.6 0 5.98.7 10.07 2.1 12.28 1.41 2.21 3.38 3.33 5.92 3.33 2.46 0 4.32-.91 5.58-2.7 1.25-1.78 2.17-4.38 2.74-7.78zm19.02-31.9h34.41v11.54h-21.5v8.59h19.93v11.01h-19.93v10.63h22.14v12.21h-35.05V57.44zM100.07 193.86c-4.15 0-7.51-3.37-7.51-7.52 0-4.15 3.36-7.52 7.51-7.52h149.69c4.15 0 7.52 3.37 7.52 7.52 0 4.15-3.37 7.52-7.52 7.52H100.07zm0 123.17c-4.15 0-7.51-3.36-7.51-7.51a7.51 7.51 0 0 1 7.51-7.52h183.31c3.42 0 6.3 2.28 7.21 5.4-7.16 2.56-14.01 5.8-20.47 9.63H100.07zm0-45.61a7.51 7.51 0 0 1-7.51-7.52c0-4.15 3.36-7.51 7.51-7.51h149.69c4.15 0 7.52 3.36 7.52 7.51 0 4.16-3.37 7.52-7.52 7.52H100.07zm220.62-38.05H72.71v149.22h144.75c-1.58 4.88-2.86 9.9-3.81 15.04H65.19c-4.15 0-7.51-3.37-7.51-7.52V148.45c0-4.15 3.36-7.52 7.51-7.52h263.02c4.15 0 7.52 3.37 7.52 7.52v152.13a119.1 119.1 0 0 0-15.04.3v-67.51zM72.71 218.33h247.98v-62.36H72.71v62.36zm231.2 186.57 15.64 14.77 35.47-36.59c3.07-3.1 4.99-5.6 8.76-1.7l12.26 12.54c4.02 3.98 3.82 6.32.02 10.03l-49.51 49.29c-8.01 7.85-6.61 8.33-14.73.28l-28.55-28.39c-1.69-1.82-1.51-3.67.35-5.51l14.22-14.75c2.16-2.27 3.87-2.07 6.07.03z"
            />
          </svg>
          <br />
          <span>{{ $t('taxVerification') }}</span>
        </label>
      </li>
      <li :title="$t('logo')">
        <label for="tab5" role="button" style="font-size: 1.8em;">
          <svg viewBox="0 0 24 24">
            <path
              d="M16.9,0H5.1A4.11,4.11,0,0,0,1,4.1V15.9A4.11,4.11,0,0,0,5.1,20H16.9A4.11,4.11,0,0,0,21,15.9V4.1A4.11,4.11,0,0,0,16.9,0Zm2.93,15.9a2.94,2.94,0,0,1-2.93,2.93H5.1A2.94,2.94,0,0,1,2.17,15.9V4.1A2.94,2.94,0,0,1,5.1,1.17H16.9A2.94,2.94,0,0,1,19.83,4.1Z"
              transform="translate(-1 0)"
            />
            <path
              d="M12.94,4.83a1,1,0,0,0-1.79-.24L11,4.85l-.15-.26a1,1,0,0,0-1.33-.36h0a1,1,0,0,0-.36,1.34L9.87,6.8,7.24,11.37H5.32a1,1,0,1,0,0,2h7.41l-1.12-2H9.49l3.35-5.8A1,1,0,0,0,12.94,4.83Z"
              transform="translate(-1 0)"
            />
            <path
              d="M16.68,11.37H14.76L12.58,7.58l-1.13,2,3.39,5.87a1,1,0,0,0,.59.46,1.15,1.15,0,0,0,.26,0,1.05,1.05,0,0,0,.49-.13,1,1,0,0,0,.35-1.34l-.64-1.11h.79a1,1,0,1,0,0-2Z"
              transform="translate(-1 0)"
            />
            <path
              d="M5.66,14.1l-.19.33a1,1,0,0,0,.35,1.34,1,1,0,0,0,.49.13,1,1,0,0,0,.85-.49l.75-1.31Z"
              transform="translate(-1 0)"
            />
          </svg>
          <br />
          <span>{{ $t('logo') }}</span>
        </label>
      </li>
      <li :title="$t('generalTerms1')">
        <label for="tab6" role="button" style="font-size: 1.8em;">
          <svg
            version="1.1"
            id="law_1_"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 128 128"
            style="enable-background:new 0 0 128 128;"
            xml:space="preserve"
          >
            <g id="row3_1_">
              <path
                id="handcuff_1_"
                class="st0"
                d="M53.8,25.4c-5.1,0-9.3,4.1-9.3,9.3c0,1.3,0.3,2.5,0.8,3.7c-1.7-1.7-4-2.8-6.6-2.8
		c-5.1,0-9.3,4.1-9.3,9.3c0,2,0.7,3.9,1.8,5.4l-8.3-2.7c0,0-1.5,4.6-3.6,11.2C10.9,61,4.2,67,1.3,75.8c-4,12.3,1.4,25.4,12.2,31.6
		c0.2,0.1,0.6,0.4,0.6,0.4s-2.3-1.3-1.6-3.4c0.8-2.4,3.9-1.1,3.9-1.1s-0.3-0.2-0.5-0.3C7.2,98,2.9,87.4,6.1,77.4
		c3.7-11.5,16-17.8,27.5-14.1c11.5,3.7,17.8,16,14.1,27.5c-3.2,10-13,16.1-23,15c-0.2,0-0.6-0.1-0.6-0.1s2.7,0.6,1.9,3.7
		c-0.3,1.3-3.7,1.2-2.4,1.4c12.6,1.6,24.9-5.9,28.9-18.4c2.8-8.6,0.6-17.7-4.5-24.4c1.6-5,3.6-11.2,3.6-11.2l-10.1-3.3
		c3.7-1.2,6.3-4.7,6.3-8.8c0-1.3-0.3-2.5-0.8-3.7c1.7,1.7,4,2.8,6.6,2.8c5.1,0,9.3-4.1,9.3-9.3C63,29.5,58.9,25.4,53.8,25.4z
		 M37.3,57.4c-0.6,1.8-2.1,2.9-3.4,2.4c-1.3-0.4-1.9-2.2-1.4-4c0.5-1.5,1.7-2.5,2.9-2.5c0.3,0.1,0.7,0.2,1.1,0.3
		C37.4,54.4,37.8,55.9,37.3,57.4z M38.6,50.6c-3.3,0-5.9-2.6-5.9-5.9c0-3.3,2.6-5.9,5.9-5.9c3.3,0,5.9,2.6,5.9,5.9
		C44.5,48,41.9,50.6,38.6,50.6z M53.8,40.5c-3.3,0-5.9-2.6-5.9-5.9c0-3.3,2.6-5.9,5.9-5.9c3.3,0,5.9,2.6,5.9,5.9
		C59.7,37.9,57,40.5,53.8,40.5z M124.7,64.7c-4.3-8-12.4-12.6-20.8-13.6c-2.5-4.6-5.6-10.4-5.6-10.4L88.7,46
		c0.8-1.4,1.3-2.9,1.3-4.6c0-5.1-4.1-9.3-9.3-9.3c-1.3,0-2.5,0.3-3.7,0.8c1.7-1.7,2.8-4,2.8-6.6c0-5.1-4.1-9.3-9.3-9.3
		c-5.1,0-9.3,4.1-9.3,9.3c0,5.1,4.1,9.3,9.3,9.3c1.3,0,2.5-0.3,3.7-0.8c-1.7,1.7-2.8,4-2.8,6.6c0,5,3.9,9,8.8,9.2l-8.5,4.6
		c0,0,2.3,4.3,5.6,10.4c-4,7.7-4.4,16.6,0.1,24.8c6.2,11.4,19.4,16.5,31.3,13c0.2-0.1,0.7-0.2,0.7-0.2s-2.5,0.7-3.6-1.2
		c-1.2-2.3,1.9-3.6,1.9-3.6s-0.3,0.1-0.5,0.2c-9.7,2.9-20.4-1.3-25.4-10.6c-5.8-10.6-1.8-23.9,8.8-29.6c10.6-5.8,23.9-1.8,29.6,8.8
		c5,9.2,2.7,20.5-5,27c-0.1,0.1-0.4,0.4-0.4,0.4s2.3-1.5,4,1.2c0.7,1.1-1.7,3.5-0.7,2.7C127.9,90.3,131,76.2,124.7,64.7z M70.6,32.1
		c-3.3,0-5.9-2.6-5.9-5.9c0-3.3,2.6-5.9,5.9-5.9c3.3,0,5.9,2.6,5.9,5.9C76.5,29.5,73.8,32.1,70.6,32.1z M74.8,41.3
		c0-3.3,2.6-5.9,5.9-5.9c3.3,0,5.9,2.6,5.9,5.9c0,3.3-2.6,5.9-5.9,5.9C77.4,47.2,74.8,44.6,74.8,41.3z M88.3,55.8
		c-1.2,0.7-2.9-0.1-3.8-1.8c-0.9-1.6-0.6-3.5,0.6-4.2c1.2-0.7,2.9,0.1,3.8,1.8C89.8,53.2,89.5,55.1,88.3,55.8z"
              />
              <g id="judge_2_" class="st1">
                <path
                  id="judge"
                  class="st2"
                  d="M113,33.5c-1.3-2.2-3.6-3-5.8-1.7c2.6-1.5,3.5-4.7,2-7.3c-1.5-2.5-4.7-3.4-7.3-2
			c0.6-0.4,3.9-2.6,1.4-6.9c-1.5-2.6-4.8-3.4-7.4-2c0,0,0,0-2.8,1.2C87.4,6,76.7,0,64.5,0C52,0,41.1,6.2,35.5,15.3
			c-2-0.8-3.5-1.7-3.5-1.7c-2.6-1.5-5.8-0.6-7.3,2c-1.5,2.5-0.6,5.8,1.9,7.3c-0.7-0.3-5.3-2.5-7.7,1.6c-2.5,4.3,2,7,2.5,7.3
			c-2.2-1.3-5.1-0.5-6.3,1.7c-1.3,2.3-0.5,5.1,1.7,6.4L28.8,47c2.9,1.7,2,1,2.6,2.3c3,7,10.5,14.7,12.2,16.2
			c-13.3,0.3-23.3,2.2-23.3,16.3v7.4c0,16.4,13.5,38.7,30.1,38.7h27.1c16.6,0,30.1-22.3,30.1-38.7v-7.4c0-14.7-10.8-16.2-25-16.4
			c1.6-1.1,10.3-9.3,13.5-16.1c1.1-2.3-0.5-0.4,2.9-2.4l12.2-7.1C113.6,38.6,114.3,35.8,113,33.5z M69.5,108.1h-6.6
			c0,0-19.5-33.5-15.4-37.5c2-2,10.3,2.1,17.7,2.2c7.3,0.1,13.6-4,15.4-2.2C83.7,73.8,69.5,108.1,69.5,108.1z M92.7,45.3
			c0.5,1.8,2.1,1.5,1.2,3.2c-20.3,28.4-39.7,27.8-59.8,0.1c-0.7-1.1,0.2-1.5,1.1-3.3c1.1-2,0.7-4.3-0.9-5.8l0.4,0.3
			c2.6,1.5,5.8,0.6,7.3-2c1.5-2.5,0.6-5.7-1.9-7.2c0.6,0.3,5.2,2.4,7.7-1.6c-0.3,0.6,2.8-3.3-0.3-7c-0.2-3.1,2.6-6.9,16.9-6.9
			c13.9,0,16.6,3.4,16.3,6.2c-4,4.4-0.8,8-0.8,7.7c2.4,4,7.1,1.9,7.7,1.6c-2.5,1.5-3.4,4.7-1.9,7.2c1.5,2.6,4.8,3.4,7.4,2l1.4-0.8
			C92.3,40.3,91.4,43,92.7,45.3z"
                />
                <path
                  id="judge_1_"
                  class="st2"
                  d="M67,83.3h-4.5c0,0-2.5,11-3,13.4c0.1-0.3,1.7-1.6,3-1.5c1.6,0.1,3,1.5,3,1.5s1-1.5,3-1.5
			c2.1,0,3,2.7,3,1.5C71.5,95.5,67,83.3,67,83.3z M64.8,74.4c-2.1,0-3.8,1.7-3.8,3.7c0,2.1,1.7,3.7,3.8,3.7c2.1,0,3.8-1.7,3.8-3.7
			C68.5,76,66.8,74.4,64.8,74.4z M67,83.3h-4.5c0,0-2.5,11-3,13.4c0.1-0.3,1.7-1.6,3-1.5c1.6,0.1,3,1.5,3,1.5s1-1.5,3-1.5
			c2.1,0,3,2.7,3,1.5C71.5,95.5,67,83.3,67,83.3z M64.8,81.8c2.1,0,3.8-1.7,3.8-3.7c0-2.1-1.7-3.7-3.8-3.7c-2.1,0-3.8,1.7-3.8,3.7
			C61,80.2,62.7,81.8,64.8,81.8z M62.5,83.3c0,0-2.5,11-3,13.4c0.1-0.3,1.7-1.6,3-1.5c1.6,0.1,3,1.5,3,1.5s1-1.5,3-1.5
			c2.1,0,3,2.7,3,1.5c0-1.2-4.5-13.4-4.5-13.4H62.5z M64.8,81.8c2.1,0,3.8-1.7,3.8-3.7c0-2.1-1.7-3.7-3.8-3.7
			c-2.1,0-3.8,1.7-3.8,3.7C61,80.2,62.7,81.8,64.8,81.8z"
                />
              </g>
              <path
                id="police_x5F_car_1_"
                class="st0"
                d="M76.8,39.1H74c0-4.7-3.8-8.5-8.5-8.5c-4.7,0-8.5,3.8-8.5,8.5h-2.8V42h22.8V39.1z
		 M22.8,80.4c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C31.3,84.2,27.5,80.4,22.8,80.4z M22.8,93.2
		c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3C27,91.2,25.1,93.2,22.8,93.2z M101,80.4
		c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C109.5,84.2,105.7,80.4,101,80.4z M101,93.2
		c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3C105.3,91.2,103.3,93.2,101,93.2z M124.7,71.7l-2.6-5.9
		l-25.5-6.5L79.7,43.4H37L18.5,61.9l-10,2.8L0,73.2v15.6c0,0,6.4,0,11.4,0c0-6.3,5.1-11.4,11.4-11.4c6.3,0,11.4,5.1,11.4,11.4
		c0,0,1.4,0,55.5,0c0-6.3,5.1-11.4,11.4-11.4c6.3,0,11.4,5.1,11.4,11.4c4.7,0,11.4,0,11.4,0l1-3.6l3.3-1.1V73.5L124.7,71.7z M37,69
		H25.6v-2.8H37V69z M56.9,61.9H25.6l12.8-14.2h18.5V61.9z M74,69H62.6v-2.8H74V69z M61.2,61.9V47.6h17.1l14.2,14.2H61.2z M0,64.7
		v5.7l5.7-5.7H0z"
              />
              <g id="prison_2_" class="st1">
                <path
                  id="person_1_"
                  class="st2"
                  d="M59.3,33.2v-2.4h-4.5c-0.8,1.2-1.5,2.6-1.9,3.9l1.2-1.6H59.3z M82.9,97.2H71.1v4.7h11.8V97.2z
			 M82.9,87.7H71.1v4.7h11.8V87.7z M82.9,106.6H71.1v2.4h11.8V106.6z M82.9,78.3H71.1V83h11.8V78.3z M80,34.9
			c-0.4-1.4-1-2.8-1.9-4.1h-7v2.4h7.6L80,34.9z M78.1,30.7c-1.7-2.6-4.2-4.8-7-6v3.7h3.5L78.1,30.7z M80.6,38.5c0-1-0.2-2-0.4-2.9
			h-9.1v17.6C76.3,50.5,80.6,44.1,80.6,38.5z M82.9,68.8H71.1v4.7h11.8V68.8z M59.3,28.4v-2.3c-1.7,1.2-3.2,2.7-4.4,4.4l3.3-2.1
			H59.3z M59.3,78.3H47.4V83h11.8V78.3z M82.9,113.8H71.1v0H59.3v0H47.4v0H44v2.3h39.7v-2.3L82.9,113.8L82.9,113.8z M59.3,68.8H47.4
			v4.7h11.8V68.8z M87.5,56.9H71.1V64h11.8v-4.8h11.8V64h2.4v4.7h-2.4v4.7h4.8v4.8h-4.8V83h4.8v4.7h-4.8v4.7h4.8v4.8h-4.8v4.7h4.8
			v4.7h-4.8v2.4h4.8v3.6c2.4-3.8,2.4-10.7,2.4-15.5V64C99.6,56.9,92.1,56.9,87.5,56.9z M94.8,113.8h-4.2c1.3,1,2.9,1.5,4.5,1.5
			c1.5,0,2.7-0.6,3.6-1.5L94.8,113.8L94.8,113.8z M59.3,87.7H47.4v4.7h11.8V87.7z M35.6,113.8h-5.1v-4.7h5.1v-2.4h-4.8v-4.7h4.8
			v-4.7h-4.8v-4.8h4.8v-4.7h-4.8V83h4.8v-4.7h-4.8v-4.8h4.8v-4.7h-2.4V64h2.4v-4.8h11.8V64h11.8v-7.1c-5,0-9.1,0-15.5,0
			c-4.6,0-7.6-0.3-11,2.9c-4.7,5.4-4.2,3.7-4.2,18.7v18.7c0,7.4-1.2,19,6.1,19c2.8,0,4.5-0.9,5.4-2.4L35.6,113.8L35.6,113.8z
			 M59.3,52V35.6h-6.6c-0.3,1-0.4,2.1-0.4,3.1C52.2,43.6,55.2,48.9,59.3,52z M59.3,97.2H47.4v4.7h11.8V97.2z M47.4,109.1h11.8v-2.4
			H47.4V109.1z"
                />
                <path
                  id="prison_1_"
                  class="st2"
                  d="M128,16.6V7.1H0v9.5h14.2v94.8H0v9.5h128v-9.5h-11.9V16.6H128z M21.3,111.4V16.6h16.6v94.8
			H21.3z M45,111.4V16.6h16.6v94.8H45z M68.7,111.4V16.6h16.6v94.8H68.7z M109,111.4H92.4V16.6H109V111.4z"
                />
              </g>
              <g id="fingerprint_1_" class="st1">
                <path
                  id="border_1_"
                  class="st2"
                  d="M4,40l8,0.1V8h31.9V0H4V40z M84,0v8h32v32h8l0-40H84z M12,88H4v40h39.9v-8H12V88z M116,120H84
			v8h40l0-39.9h-8V120z"
                />
                <path
                  id="icon"
                  class="st2"
                  d="M72.2,71.6c0-7.9-3.4-14.4-8.2-14.4s-8.2,6.4-8.2,14.4c0,7.9,3.4,14.4,8.2,14.4
			S72.2,79.5,72.2,71.6z M64,81.1c-3.5,0-4.9-4.2-4.9-9.5c0-5.3,1.4-9.6,4.9-9.6s5,4,5,9.3C69,76.6,67.5,81.1,64,81.1z M64,47.7
			c-9,0-15.3,10.7-15.3,23.9c0,7.5,2,14.2,5.4,18.6c2.6,3.3,6.9-0.6,5.6-1.5c-4.2-2.8-6.7-9.9-6.7-18.1c0-10.7,4.4-17.6,11-17.6
			s11,6.8,11,17.6c0,8.1-2.5,15-6.5,17.9c-1.3,1,2.5,5.1,5,2.1c3.6-4.4,5.8-11.3,5.8-19.1C79.3,58.4,73,47.7,64,47.7z M64,38.1
			c-14.6,0-24.7,15-24.7,33.5c0,7.6,1.7,14.7,4.8,20.3c4.3,8,7.8,5.2,4.1-0.9c-3.1-5.2-4.8-12-4.8-19.4c0-16.2,8.3-29.3,20.6-29.3
			s20.6,13.1,20.6,29.3c0,7.8-1.9,14.8-5.3,20.1c-3.6,5.7-0.4,8.7,4,1.2c3.4-5.8,5.3-13.2,5.3-21.3C88.7,53.1,78.6,38.1,64,38.1z
			 M64,16c-24.3,0-44,24.5-44,54.7c0,10.5,2.4,20.3,6.5,28.7c7.7,15.6,11,12.4,4.3-2.4c-3.4-7.4-5.3-16.1-5.3-25.4
			c0-27.6,17.2-50,38.5-50s38.5,22.4,38.5,50c0,10-2.3,19.3-6.2,27.1c-6.9,13.8-3.8,17,4.1,2.5c4.7-8.7,7.5-19.2,7.5-30.5
			C108,40.5,88.3,16,64,16z M98.1,71.6c0-25.1-14-45.5-34.1-45.5S29.9,46.5,29.9,71.6c0,8.6,1.6,16.7,4.6,23.6c5.7,13.1,10,9,5.2-2
			C37,87,35.5,79.6,35.5,71.6c0-22,11.5-39.8,28.5-39.8s28.5,17.8,28.5,39.8c0,8.5-1.7,16.4-4.8,22.8c-4.9,10.3-0.7,14.5,5.1,2.2
			C96.2,89.4,98.1,80.8,98.1,71.6z"
                />
              </g>
            </g>
            <g id="row2_1_">
              <path
                id="gun_1_"
                class="st0"
                d="M41.4,62c-4.8-3.6-7.5-8.9-9.9-9.7c-4.2-1.5-8.4-0.1-9,7c-0.6,7.1-0.3,7.1-2.8,9.1
		c-1.5,1.3-10.7,8-16,17.5c-3.3,5.9-4.1,9.4-3.5,11.6c1.6,5.8,1.3,8.4,7.6,9.1c6.3,0.7,21.9,0.9,25-0.7c3.2-1.6,8.3-2.6,9-14.7
		c0.8-12.1-0.5-16.4,6.3-16.6c2.1,0,6.6-0.6,4.2-5.3C50.1,65.3,44.6,64.4,41.4,62z M33.5,74.1c-2.7,0-4.9-2.2-4.9-4.9
		c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9C38.4,71.9,36.2,74.1,33.5,74.1z M123.1,31.1V20.7l-14.6,10.4H84.4l-1.7-4.5H55.1
		c0,0-5.4,6.7-5.6,9.3c-3.7-1.2-15.2-3.4-18-0.7c-2.8,2.7-1.4,5.4,1.4,5.5c2.7,0.1,10.1,2.8,8.3,4.8c-1.7,2-8.3,4.1-8.3,4.1
		s3.5,4.5,10.4,10.3c1.8,1.5,5.6,2.3,7.9,3.9c3.3,2.5,4.9,5.8,5.3,7.8c1.8,8.4,6.1,15.6,16,16.6c14.4,1.4,23-6.9,23.6-11.7
		c0.7-5.4,1.3-21.7,1.3-21.7h18l0.5-5.4H128V31.1H123.1z M63,33.3h12.8c1,0,1.7,0.8,1.7,1.8c0,1-0.8,1.8-1.7,1.8H63
		c-1,0-1.7-0.8-1.7-1.8C61.3,34.1,62.1,33.3,63,33.3z M63,40.6h12.8c1,0,1.7,0.8,1.7,1.8c0,1-0.8,1.8-1.7,1.8H63
		c-1,0-1.7-0.8-1.7-1.8C61.3,41.4,62.1,40.6,63,40.6z M61.3,49.6c0-1,0.8-1.8,1.7-1.8h12.8c1,0,1.7,0.8,1.7,1.8c0,1-0.8,1.8-1.7,1.8
		H63C62.1,51.4,61.3,50.6,61.3,49.6z M80.8,82.2h-9c-5.4,0-9.7-5-9.7-10.4c0-2.9,1.3-4.9,3.4-6.1c1.7-1,6.1,12.7,14,12.3
		c0,0-6.5-13.8-5-13.8c2.7,0,6.4,0,6.4,0c5.4,0,9.7,2.3,9.7,7.6C90.5,77.2,86.2,82.2,80.8,82.2z"
              />
              <path
                id="investigate_1_"
                class="st0"
                d="M4.8,103c0,11.8,6.8,21.4,18.1,21.4c11.3,0,18.1-9.6,18.1-21.4v-7.6H4.8V103z M36.3,13.8
		C32.5,7.4,27.9,3.6,22.9,3.6C10.3,3.6,0,27.9,0,58c8.3,26.9,4.8,32.6,4.8,32.6h36.2c0,0-1.7-9,0.6-20.6
		C35,71.3,12.2,36.7,36.3,13.8z M125.9,90.3L110.5,75c-2.3-2.3-5.8-2.6-8.6-1L91.2,63.2c5.7-6.3,9.2-14.7,9.2-23.8
		c0-19.7-16-35.7-35.7-35.7S29,19.6,29,39.3C29,59,44.9,75,64.7,75c8,0,15.3-2.6,21.2-7l11,11c-1.6,2.7-1.3,6.2,1,8.6l15.4,15.4
		c2.8,2.8,7.3,2.8,10.1,0l2.5-2.5C128.7,97.6,128.7,93.1,125.9,90.3z M64.6,65.9c-14.8,0-26.8-12-26.8-26.8
		c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8C91.4,53.9,79.4,65.9,64.6,65.9z M65.2,25.4c-13.3,0-24.2,6.5-24.2,14.5
		c0,8,10.8,14.5,24.2,14.5c13.3,0,24.2-6.5,24.2-14.5C89.4,31.8,78.6,25.4,65.2,25.4z M65.2,49.5c-5.3,0-9.7-4.3-9.7-9.7
		s4.3-9.7,9.7-9.7s9.7,4.3,9.7,9.7S70.5,49.5,65.2,49.5z M65.2,32.6c-2.7,0-4.8,2.2-4.8,4.8c0,2.7,2.2,4.8,4.8,4.8
		c2.7,0,4.8-2.2,4.8-4.8C70,34.8,67.9,32.6,65.2,32.6z"
              />
              <path
                id="archive_1_"
                class="st0"
                d="M123.5,9.1H91.3c-2.5,0-4.5,2-4.5,4.4v101c0,2.4,2,4.4,4.5,4.4h32.2c2.5,0,4.5-2,4.5-4.4v-101
		C128,11.1,126,9.1,123.5,9.1z M121.1,109.7H93.7v-4.6h27.4V109.7z M93.7,80c0-7.6,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7
		c0,7.6-6.1,13.7-13.7,13.7C99.8,93.7,93.7,87.5,93.7,80z M121.1,102.9H93.7v-4.6h27.4V102.9z M121.1,45.7H93.7v-4.6h27.4V45.7z
		 M121.1,36.5H93.7V32h27.4V36.5z M121.1,27.4H93.7v-4.6h27.4V27.4z M20.5,89.1c5,0,9.1-4.1,9.1-9.1c0-5.1-4.1-9.1-9.1-9.1
		c-5,0-9.1,4.1-9.1,9.1C11.4,85,15.5,89.1,20.5,89.1z M107.4,89.1c5,0,9.1-4.1,9.1-9.1c0-5.1-4.1-9.1-9.1-9.1c-5,0-9.1,4.1-9.1,9.1
		C98.2,85,102.3,89.1,107.4,89.1z M80.1,9.1H47.9c-2.5,0-4.5,2-4.5,4.4v101c0,2.4,2,4.4,4.5,4.4h32.2c2.5,0,4.5-2,4.5-4.4v-101
		C84.6,11.1,82.6,9.1,80.1,9.1z M77.7,109.7H50.3v-4.6h27.4V109.7z M50.3,80c0-7.6,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7
		c0,7.6-6.1,13.7-13.7,13.7C56.4,93.7,50.3,87.5,50.3,80z M77.7,102.9H50.3v-4.6h27.4V102.9z M77.7,45.7H50.3v-4.6h27.4V45.7z
		 M77.7,36.5H50.3V32h27.4V36.5z M77.7,27.4H50.3v-4.6h27.4V27.4z M36.7,9.1H4.5C2,9.1,0,11.1,0,13.5v101c0,2.4,2,4.4,4.5,4.4h32.2
		c2.5,0,4.5-2,4.5-4.4v-101C41.2,11.1,39.2,9.1,36.7,9.1z M34.3,109.7H6.8v-4.6h27.4V109.7z M6.8,80c0-7.6,6.1-13.7,13.7-13.7
		S34.2,72.4,34.2,80c0,7.6-6.1,13.7-13.7,13.7S6.8,87.5,6.8,80z M34.3,102.9H6.8v-4.6h27.4V102.9z M34.3,45.7H6.8v-4.6h27.4V45.7z
		 M34.3,36.5H6.8V32h27.4V36.5z M34.3,27.4H6.8v-4.6h27.4V27.4z M64,89.1c5,0,9.1-4.1,9.1-9.1c0-5.1-4.1-9.1-9.1-9.1
		c-5,0-9.1,4.1-9.1,9.1C54.8,85,58.9,89.1,64,89.1z"
              />
              <path
                id="Court_1_"
                class="st0"
                d="M72.1,104V58.3h5.2v-5H50.7v4.8h5.2V104H72.1z M2.3,50.6c0,0,123.3,0,123.5,0
		c3-1.3,2.8-4.1,0.1-6C123.1,42.8,64,0,64,0S5.3,42.8,2.3,44.7C-0.6,46.5-0.8,49.3,2.3,50.6z M65.3,21.3c5.2,0,9.4,4.2,9.4,9.3
		c0,5.1-4.2,9.3-9.4,9.3c-5.2,0-9.4-4.2-9.4-9.3C56,25.5,60.2,21.3,65.3,21.3z M114.7,104V58.3h5.2v-5H93.3v4.8h5.2V104H114.7z
		 M45.3,120h37.3v-5.3H45.3V120z M50.7,112h26.7v-5.3H50.7V112z M88,128h40v-5.3H88V128z M32.1,104V58.9h5.2v-5.6H10.6v5.1h5.2V104
		H32.1z M85.3,120H128v-10.7H85.3V120z M0,128h40v-5.3H0V128z M42.7,109.3H0V120h42.7V109.3z M42.7,128h42.6v-5.3H42.7V128z"
              />
              <path
                id="certificate"
                class="st3"
                d="M15.5,62.1L18,66c0,0,5.3-11.2,5.3-11.1c-2.7-0.1-1.6-2.9-5-3c-1.5,0-1.7-0.7-1.7-0.7
		l-5.7,11.4L15.5,62.1z M14,45.5c1.2,0.8,1.9,1.9,1.9,3.3c0,1.5,0.8,2.2,2.2,2.2c1.4,0,2.5,0.7,3.3,1.9c0.7,1.3,1.7,1.5,3,0.8
		c1.3-0.7,2.5-0.7,3.8,0c1.3,0.7,2.3,0.4,3-0.8c0.7-1.3,1.8-1.9,3.3-1.9c1.4,0,2.2-0.8,2.2-2.2c0-1.5,0.6-2.6,1.9-3.3
		c1.2-0.8,1.5-1.8,0.8-3.1c-0.7-1.3-0.7-2.6,0-3.9c0.7-1.3,0.4-2.3-0.8-3.1c-1.2-0.8-1.9-1.9-1.9-3.3c0-1.5-0.8-2.2-2.2-2.2
		c-1.4,0-2.5-0.7-3.3-1.9c-0.7-1.3-1.7-1.5-3-0.8c-1.3,0.7-2.5,0.7-3.8,0c-1.3-0.7-2.3-0.4-3,0.8c-0.7,1.3-1.8,1.9-3.3,1.9
		c-1.4,0-2.2,0.8-2.2,2.2c0,1.5-0.7,2.6-1.9,3.3c-1.2,0.8-1.5,1.8-0.8,3.1c0.7,1.3,0.7,2.6,0,3.9C12.4,43.8,12.7,44.8,14,45.5z
		 M26.3,30.4c5.5,0,9.9,4.5,9.9,10.1c0,5.6-4.5,10.1-9.9,10.1s-9.9-4.5-9.9-10.1C16.3,35,20.8,30.4,26.3,30.4z M31.5,54
		c-1.1,1.2-2.5,1-2.5,1l6.4,11.3l1.6-4.2l4.5,0.6l-5.8-11C31.6,52.1,32.5,53.1,31.5,54z M26.3,49.5c4.8,0,8.8-4,8.8-8.9
		c0-4.9-3.9-8.9-8.8-8.9c-4.8,0-8.8,4-8.8,8.9C17.5,45.5,21.4,49.5,26.3,49.5z M83.1,109.9H6.6V18.1h59.1v13.1h17.5V64l6.6-8.2V29
		L71.9,11.5H0v105h89.7V84.1l-6.6,5.2V109.9z M69.8,98.5l-6,7.8l14.5-7.7l4.5-10.8l-7.3-5.6l-9.3,6.9l-3.6,16.3l6.1-7.9
		c-0.6-1.1-0.6-3.1,0.2-4.2c1.1-1.5,3.2-1.8,4.6-0.7c1.4,1.1,1.7,3.2,0.5,4.7C73.1,98.4,71,98.8,69.8,98.5z M72.2,42.1H48.1v4.4
		h24.1V42.1z M67.8,81.5H15.3v4.4h52.5V81.5z M79.9,73.6c-1.5,1.9-2,7.9-2,7.9l4.6,3.6c0,0,5.5-2,7.1-3.9c1.5-2,10.9-14,10.9-14
		l-9.7-7.5C90.8,59.6,81.3,71.7,79.9,73.6z M72.2,68.4H15.3v4.4h56.9V68.4z M61.3,94.6H15.3V99h45.9V94.6z M48.1,59.6h24.1v-4.4
		H48.1V59.6z M118.3,24.1L93,56.7l9.7,7.5L128,31.6L118.3,24.1z"
              />
            </g>
            <g id="row1_1_" class="st1">
              <g id="law_x5F_book_1_" class="st4">
                <path
                  id="book"
                  class="st3"
                  d="M14.2,14.8V9.8c0-2.7,2.2-4.9,4.9-4.9h98.1C115.6,2,112.4,0,108.7,0H19.2c-5.4,0-9.8,4.4-9.8,9.8
			v108.3c0,5.4,4.4,9.8,9.8,9.8h3.5V18.7H20C17.3,18.7,14.2,17.5,14.2,14.8z M28,18.7V128h80.6c5.6,0,10.1-4.5,10.1-9.9V18.7H28z
			 M82.8,87.5c0,7.4-5.2,11.2-12,11.2c-7.7,0-12.1-4-12.1-12.3h9.2v1.2c0,1.6,0.6,4.5,2.9,4.5c1.9,0,2.9-1.4,2.9-3.2
			c0-6.6-16.3-5.9-16.3-19.7c0-3.5,1.8-6.8,4.4-8.8v-0.1c-0.5,0-2.4-3.2-2.4-6.2c0-7.1,5.1-11.3,11.6-11.3c8.1,0,11.8,3.9,11.8,12.3
			h-9.2v-1.8c0-1.8-0.5-3.6-2.7-3.6c-1.4,0-2.6,1.5-2.6,3c0,6.8,15.9,6.9,15.9,18.6c0,3.5-1.4,6.9-3.9,9.2
			C82,82.6,82.8,84.6,82.8,87.5z M73.8,70c-1.9-1.1-6.2-3.8-7.8-5.3c-0.6,1-1.3,2-1.3,3.2c0,2.8,6.7,5.3,10.1,8.1
			c0.6-0.4,1.5-1.5,1.5-2.6C76.3,71.9,75.2,70.8,73.8,70z"
                />
              </g>
              <path
                id="justice_2_"
                class="st5"
                d="M102.9,23.2L85.4,64h-5.3l17.8-43.3H72.8V111h35.1l0,12.5H22.5l0-12.5h37.6V20.7H32.6l16.4,44
		h-5.2L27.6,23.2L7.9,64.7H2.7l19.9-44v-7.5h35.1c0-11.8,17.6-11.5,17.6,0h32.6v7.5L127,64h-5.3L102.9,23.2z M50.2,68.4
		c0,12.8-10.5,23.1-25.7,23.1C9.6,91.4,0,81.2,0,68.4C0,68.4,50.2,68.4,50.2,68.4z M80.3,68.4c0,0,47.7,0,47.7,0
		c0,12.8-9.3,25.1-24,25.1C89.6,93.5,80.3,81.2,80.3,68.4z"
              />
              <path
                id="Gavel_1_"
                class="st2"
                d="M43.2,26.1l30.6,11c2.4,0.9,5.1-0.3,6-2.7c0.9-2.4-0.3-5-2.7-5.8l-30.6-11
		c-2.4-0.9-5.1,0.3-6,2.7C39.5,22.6,40.8,25.2,43.2,26.1z M25.4,73l30.6,11c2.4,0.9,5.1-0.3,6-2.7c0.9-2.4-0.3-5-2.7-5.8l-30.6-11
		c-2.4-0.9-5.1,0.3-6,2.7C21.8,69.5,23,72.2,25.4,73z M123.4,69.5L68.1,52l4-10.7l-30.6-11L30.2,60.2l30.6,11l4-10.7l53.7,21.8
		c3.6,1.3,7.6-0.5,9-4C128.9,74.7,127.1,70.8,123.4,69.5z M64.2,97.2c0-2.6-2.1-4.7-4.7-4.7h-42c-2.6,0-4.7,2.1-4.7,4.7
		c0,2.6,0,4.7,0,4.7l-4.8-0.1l0.2,8.9h60.6l0.2-8.6l-4.6-0.2C64.5,101.9,64.2,99.8,64.2,97.2z M7.6,84.3c-4.2,0-7.6,1.4-7.6,3
		c0,1.7,3.4,3,7.6,3c4.2,0,16.8-3,16.8-3S11.7,84.3,7.6,84.3z M10.7,77.4c3.6,2.2,16,6.1,16,6.1s-9.2-9.1-12.8-11.3
		c-3.6-2.2-7.2-2.7-8.1-1.3C5,72.3,7.1,75.3,10.7,77.4z"
              />
              <path
                id="lawyer_2_"
                class="st5"
                d="M98.1,74.1c0,0-14.5-10.7-34.4-10.7c-19.5,0-33.9,10.7-33.9,10.7l-10.8-5.2l-0.1,16.5L22,95.6
		h-9.4l3.2-10.3l-0.1-17.9L0,59.8l64.1-27.4L128,60.3L98.1,74.1z M63.1,65.6c20.2,0,30.1,8.1,30.1,8.1v17.2H34.8V73.7
		C34.8,73.7,42.9,65.6,63.1,65.6z"
              />
              <path
                id="police_1_"
                class="st2"
                d="M64,40c-14,0-25.3,11.3-25.3,25.3c0,14,11.3,25.3,25.3,25.3s25.3-11.3,25.3-25.3
		C89.3,51.3,78,40,64,40z M74.7,80L64,75.1L53.3,80l1.5-11.4l-8.1-8.4l11.6-2.2L64,48l5.7,10.1l11.6,2.2l-8.1,8.4L74.7,80z M64,13.3
		c-12.3,13.5-34.7,15.3-46.1,7.3l-3.2,8.7c0,0,5.3,0.7,5.3,12.7c0,60,35.9,67,44,72.7c8.1-5.7,44.4-11.8,44.4-72.4
		c0-12.4,5-15.6,5-15.6l-3-5.9C98.9,28.7,76.3,26.8,64,13.3z M64,96c-16.9,0-30.7-13.7-30.7-30.7c0-16.9,13.7-30.7,30.7-30.7
		s30.7,13.7,30.7,30.7C94.7,82.3,80.9,96,64,96z M116.7,6c-16.8,9.8-34.7,10.6-53-6c-18.3,16.6-38.1,15.8-55,6L1.3,32
		c0,0,5.7,3.2,5.7,9.4c0,73.2,44.7,79.6,56.6,86.6c11.9-7,57.3-13.3,57.3-86.6c0-6.2,5.7-12.1,5.7-12.1L116.7,6z M113.3,45.3
		c0,64-39.1,68.6-49.3,74.7c-10.2-6.1-49.3-13.2-49.3-77.3c0-13.3-5.4-12.2-5.4-12.2l4.8-16.1C28.6,22.9,48.3,22.5,64,8
		c15.7,14.5,35.4,14.9,49.9,6.3l4.8,15C118.7,29.3,113.3,32,113.3,45.3z"
              />
            </g>
          </svg>
          <br />
          <span>{{ $t('generalTerms1') }}</span>
        </label>
      </li>
    </ul>
    <div class="slider">
      <div class="indicator"></div>
    </div>
    <div class="content">
      <section>
        <h2>{{ $t('details') }}</h2>
        <div class="about-container">
          <!--SHOWS WHEN COMPANY DETAILS ARE ENTERED -->
          <div
            v-if="isCompanyDetailsEntered === true"
            class="companyCard companyDetailsEntered"
          >
            <br />
            <CardCompany :client="clientDetails" />
          </div>

          <!--SHOWS ON FIRST SIGN-IN -->
          <div v-else class="companyDetailsEmpty">
            <figure class="about-img2">
              <img src="../../assets/static/images/illustrations/company.svg" />
            </figure>
            <button
              class="add-btn"
              @click="$bvModal.show('companyDetails-modal')"
            >
              {{ $t('add') }} {{ $tc('companyDetails', 2) }}
            </button>
            <!--LINK TO MODAL --->
            <b-modal id="companyDetails-modal" hide-footer>
              <template v-slot:modal-title>
                {{ $t('addCompanyDetails') }}
              </template>
              <ClientDetailsModal
                :clientDetails="clientDetails"
                @exit="closeCompanyDetailsModal"
              />
            </b-modal>
            <!--END OF MODAL-->
          </div>
        </div>
      </section>
      <section>
        <h2>{{ $tc('contact', 2) }}</h2>
        <div class="about-container">
          <!--SHOWS WHEN COMPANY DETAILS ARE ENTERED -->
          <div
            v-if="isContactDetailsEntered === true"
            class="companyCard contactDetailsEntered"
          >
            <br />
            <CardContacts :client="clientDetails" />
          </div>

          <!--SHOWS ON FIRST SIGN-IN -->
          <div v-else class="contactDetailsEmpty">
            <figure class="about-img2">
              <img src="../../assets/static/images/illustrations/company.svg" />
            </figure>
            <button
              class="add-btn"
              @click="$bvModal.show('companyContacts-modal')"
            >
              {{ $t('addContactDetails') }}
            </button>
            <!--LINK TO MODAL --->
            <b-modal id="companyContacts-modal" hide-footer>
              <template v-slot:modal-title>
                {{ $t('addCompanyContacts') }}
              </template>
              <ClientContactsModal
                :clientDetails="clientDetails"
                @exit="closeContactDetailsModal"
              />
            </b-modal>
            <!--END OF MODAL-->
          </div>
        </div>
      </section>
      <section>
        <h2>{{ $tc('account', 3) }}</h2>
        <div class="about-container">
          <!--SHOWS WHEN KEYS ARE ENTERED -->
          <div
            v-if="
              isPaymentDetailsEntered === true ||
                isShippingDetailsEntered === true
            "
            class="companyCard paymentDetailsEntered"
          >
            <br />
            <CardStripe
              :paymentDetails="paymentDetails"
              :shippingDetails="shippingDetails"
              :isPaymentDetailsEntered="isPaymentDetailsEntered"
              :isShippingDetailsEntered="isShippingDetailsEntered"
            />
          </div>

          <!--SHOWS ONLY ON ONBOARDING - first sign-in --->
          <div v-if="!isPaymentDetailsEntered" class="paymentDetailsEmpty">
            <br />
            <br />
            <p>{{ $t('whyAddStripeKeys') }}</p>

            <button
              class="add-btn"
              @click="$bvModal.show('companyPayments-modal')"
            >
              {{ $t('addStripeKeys') }}
            </button>
            <br />
            <br />
            <div class="supplierDisclaimer">
              <!-- <label> -->
              <input
                id="box1"
                type="checkbox"
                @click="updateSupplierFlag($event)"
                :checked="clientDetails.is_supplier"
              />
              <label for="box1"></label>
              <span class="checkmark">{{ $t('onlySupplier') }}</span>
              <!-- </label>			 -->
            </div>

            <!--MODAL --->
            <b-modal id="companyPayments-modal" hide-footer>
              <template v-slot:modal-title>
                {{ $t('addPaymentAccountDetails') }}
              </template>
              <ClientPaymentsModal @exit="closePaymentDetailsModal" />
            </b-modal>
            <!-- MODAL-->

            <div class="faqStripe">
              <br />
              <FAQStripe />
            </div>
          </div>

          <div v-if="!isShippingDetailsEntered" class="paymentDetailsEmpty">
            <br />
            <button
              class="add-btn"
              @click="$bvModal.show('companyshipping-eurosender-modal')"
            >
              {{ $t('connectWithEuroSender') }}
            </button>
            <div class="faqStripe">
              <br />
              <FAQEurosender />
            </div>
            <br />
            <br />
            <button
              class="add-btn"
              @click="$bvModal.show('companyshipping-shippypro-modal')"
            >
              {{ $t('connectWithShippyPro') }}
            </button>

            <!--MODAL for shippypro --->
            <b-modal id="companyshipping-shippypro-modal" hide-footer>
              <template v-slot:modal-title>
                {{ $t('addShippingAccountDetails') }}
              </template>
              <ClientShippingModal
                platform="shippypro"
                @exit="closeShippingDetailsModal"
              />
            </b-modal>
            <!-- MODAL or shippypro-->

            <!--MODAL for eurosender --->
            <b-modal id="companyshipping-eurosender-modal" hide-footer>
              <template v-slot:modal-title>
                {{ $t('addShippingAccountDetails') }}
              </template>
              <ClientShippingModal
                platform="eurosender"
                @exit="closeShippingDetailsModal"
              />
            </b-modal>
            <!-- MODAL for eurosender-->
          </div>
        </div>
      </section>
      <section>
        <h2>{{ $t('taxVerification') }}</h2>
        <div class="about-container">
          <br />
          <TaxVerification></TaxVerification>
        </div>
      </section>
      <section>
        <h2>{{ $t('logo') }}</h2>
        <div class="about-container">
          <figure class="about-img3">
            <img
              class="uploadExample"
              src="../../assets/static/images/uploadExamples/LogoImage_example.jpg"
            />
          </figure>
          <ClientLogoUpload @updateProfile="updateProfile"></ClientLogoUpload>
        </div>
      </section>
      <section>
        <h2>{{ $t('generalTerms1') }}</h2>
        <div class="about-container">
          <div class="about-img3">
            <h5 class="termsConditionsText">
              {{ $t('termsConditionsClient') }}
            </h5>
          </div>
          <TCpdfUpload :client="clientDetails"></TCpdfUpload>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ClientLogoUpload from './ClientLogoUpload.vue'
import ClientDetailsModal from '@/components/ui/ClientDetailsModal.vue'
import ClientPaymentsModal from '@/components/ui/ClientPaymentsModal.vue'
import ClientShippingModal from '@/components/ui/ClientShippingModal.vue'
import ClientContactsModal from '@/components/ui/ClientContactsModal.vue'
import FAQStripe from '@/components/onboarding/FAQStripe.vue'
import FAQEurosender from '@/components/onboarding/FAQEurosender.vue'
import CardStripe from '@/components/ui/CardStripe.vue'
import CardCompany from '@/components/ui/CardCompany.vue'
import CardContacts from '@/components/ui/CardContacts.vue'
import TaxVerification from '../../pages/TaxVerification.vue'
import ShippingService from '@/services/ShippingService'
import TCpdfUpload from '@/components/ui/TCpdfUpload.vue'

export default {
  components: {
    ClientLogoUpload,
    ClientPaymentsModal,
    ClientShippingModal,
    ClientDetailsModal,
    ClientContactsModal,
    FAQStripe,
    FAQEurosender,
    CardStripe,
    CardCompany,
    CardContacts,
    TaxVerification,
    TCpdfUpload
  },
  methods: {
    closeCompanyDetailsModal() {
      this.$bvModal.hide('companyDetails-modal')
      this.isCompanyDetailsEntered = true
      this.getClientDetails()
    },
    closeContactDetailsModal() {
      this.$bvModal.hide('companyContacts-modal')
      this.isContactDetailsEntered = true
      this.getClientDetails()
    },
    closePaymentDetailsModal() {
      this.$bvModal.hide('companyPayments-modal')
      this.getPaymentDetails()
    },
    closeShippingDetailsModal() {
      this.$bvModal.hide('companyshipping-modal')
      this.getShippingDetails()
    },
    getClientDetails() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/clients/` + this.id)
        .then(response => {
          if (response.data.length > 0) {
            this.clientDetails = response.data[0]
            this.clientDetails.liable_for_vat = this.clientDetails.liable_for_vat.toString()
            if (
              (this.clientDetails.name !== null &&
                this.clientDetails.name !== '') ||
              (this.clientDetails.address !== null &&
                this.clientDetails.address !== '') ||
              (this.clientDetails.postal_code !== null &&
                this.clientDetails.postal_code !== '') ||
              (this.clientDetails.city !== null &&
                this.clientDetails.city !== '') ||
              (this.clientDetails.country !== null &&
                this.clientDetails.country !== '') ||
              (this.clientDetails.vat_no !== null &&
                this.clientDetails.vat_no !== '') ||
              (this.clientDetails.liable_for_vat !== null &&
                this.clientDetails.liable_for_vat !== '')
            ) {
              this.isCompanyDetailsEntered = true
            }
            if (
              (this.clientDetails.email_general !== null &&
                this.clientDetails.email_general !== '') ||
              (this.clientDetails.contact_fname !== null &&
                this.clientDetails.contact_fname !== '') ||
              (this.clientDetails.contact_lname !== null &&
                this.clientDetails.contact_lname !== '') ||
              (this.clientDetails.contact_no !== null &&
                this.clientDetails.contact_no !== '') ||
              (this.clientDetails.email_invoice !== null &&
                this.clientDetails.email_invoice !== '')
            ) {
              this.isContactDetailsEntered = true
            }
          }
        })
    },
    getPaymentDetails() {
      axios.get(`${process.env.VUE_APP_API_URL}/stripe/keys`).then(response => {
        this.paymentDetails = response.data
        if (
          (this.paymentDetails.publishable_key &&
            this.paymentDetails.publishable_key !== null &&
            this.paymentDetails.publishable_key !== '') ||
          (this.paymentDetails.secret_key &&
            this.paymentDetails.secret_key !== null &&
            this.paymentDetails.secret_key !== '')
        ) {
          this.isPaymentDetailsEntered = true
        }
      })
    },
    getShippingDetails() {
      ShippingService.getShippingKey().then(response => {
        this.shippingDetails = response.data
        if (
          this.shippingDetails &&
          this.shippingDetails.key !== null &&
          this.shippingDetails.key !== ''
        ) {
          this.isShippingDetailsEntered = true
        }
      })
    },
    updateSupplierFlag(event) {
      const client = {
        id: this.id,
        is_supplier: event.target.checked
      }
      this.$store.dispatch('client/editClient', client)
    }
  },
  data() {
    return {
      id: JSON.parse(localStorage.getItem('user')).id,
      clientDetails: {},
      isCompanyDetailsEntered: false,
      isContactDetailsEntered: false,
      isPaymentDetailsEntered: false,
      shippingDetails: {},
      isShippingDetailsEntered: false
    }
  },
  mounted() {
    this.getClientDetails()
    this.getPaymentDetails()
    this.getShippingDetails()
  }
}
</script>

<style lang="scss" scoped>
.companyDetailsEntered {
  // display: none; //! none when client_details with this client_id is already found in db //
}
.companyDetailsEmpty {
  // display: none //! none when NO client_details with this client_id is found in db //
}
.contactDetailsEntered {
  // display: none; //! none when client_details with this client_id is already found in db //
}
.contactDetailsEmpty {
  // display: none //! none when NO client_details with this client_id is found in db //
}
.paymentDetailsEntered {
  // display: none; //! none when payment details with this client_id is already found in db //
}
.paymentDetailsEmpty {
  // display: none //! none when NO payment details with this client_id is found in db //
}

/*** custom checkboxes ***/

input[type='checkbox'] {
  display: none;
} /* to hide the checkbox itself */
input[type='checkbox'] + label:before {
  font-family: FontAwesome;
  display: inline-block;
}

input[type='checkbox'] + label:before {
  content: '\f096';
} /* unchecked icon */
input[type='checkbox'] + label:before {
  letter-spacing: 10px;
} /* space between checkbox and label */

input[type='checkbox']:checked + label:before {
  content: '\f046';
} /* checked icon */
input[type='checkbox']:checked + label:before {
  letter-spacing: 5px;
} /* allow space for check mark */

/* colors */
$primary: #c95c5f;
$dark: #0c2e44;

$accent: $primary;
$accent-inactive: desaturate($accent, 85%);
$secondary: $accent-inactive;

/* tab setting */
$tab-count: 6;
$indicator-width: 150px;
$indicator-height: 4px;

/* breakpoints */
$breakpoints: (
  medium: #{$tab-count * 250px},
  small: #{$tab-count * 150px}
);

/* selectors relative to radio inputs */
$label-selector: '~ ul > li';
$slider-selector: '~ .slider';
$content-selector: '~ .content > section';

.st0 {
  display: none;
  //   fill: #0f0f0f;
}
.st1 {
  display: none;
}
.st2 {
  display: inline;
  //   fill: #0f0f0f;
}
.st3 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  //   fill: #0f0f0f;
}
.st4 {
  display: inline;
}
.st5 {
  display: inline;
  fill-rule: evenodd;
  clip-rule: evenodd;
  //   fill: #0f0f0f;
}

@mixin tabs(
  $label-selector: $label-selector,
  $slider-selector: $slider-selector,
  $content-selector: $content-selector
) {
  @for $i from 1 through $tab-count {
    &:nth-of-type(#{$i}):checked {
      #{$label-selector}:nth-child(#{$i}) {
        @content;
      }
      #{$slider-selector} {
        transform: translateX(#{100% * ($i - 1)});
      }
      #{$content-selector}:nth-child(#{$i}) {
        display: block;
      }
    }
  }
}

body {
  background: #efefef;
  color: $dark;
  height: 100%;

  h1 {
    text-align: center;
    color: $accent;
    font-weight: 300;
    padding: 40px 0 20px 0;
    margin: 0;
  }
}

.supplierDisclaimer {
  border: solid 1px;
  padding: 10px;
  margin: auto;
  width: 50%;
  border-color: var(--br);
}

.faqStripe {
  text-align: left;
}
.uploadDetails {
  font-size: 1.3em;
  text-align: center;
}

.add-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 1em;
  border-radius: 5px;
  letter-spacing: 3px;
  width: 30%;
}

.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 450px;
  text-align: center;
  vertical-align: top;
}

.about-img3 {
  display: inline-block;
  width: 100%;
  max-width: 300px;
  text-align: center;
  vertical-align: top;
}

.termsConditionsText {
  line-height: 2rem;
}

.uploadExample {
  max-width: 300px;
  width: 100%;
}

.tabs {
  left: 50%;
  transform: translateX(-50%);
  position: relative;
  background: white;
  padding: 15px;
  padding-bottom: 80px;
  width: 100%;
  height: auto;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  border-radius: 5px;
  min-width: #{$tab-count * 60px};
  input[name='tab-control'] {
    display: none;
  }

  .content section h2,
  ul li label {
    font-weight: 400;
    font-size: 18px;
    color: $accent;
    text-align: left;
  }

  ul {
    list-style-type: none;
    padding-left: 0;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;

    li {
      box-sizing: border-box;
      flex: 1;
      width: #{100% / $tab-count};
      padding: 0 10px;
      text-align: center;

      label {
        transition: all 0.3s ease-in-out;
        line-height: 1.7rem;
        color: $secondary;
        padding: 5px auto;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        white-space: nowrap;
        -webkit-touch-callout: none;
        user-select: none;
        // @include user-select(none);

        br {
          display: none;
        }

        svg {
          fill: $dark;
          height: 1.2em;
          vertical-align: bottom;
          margin-right: 0.2em;
          transition: all 0.2s ease-in-out;
        }
        &:hover,
        &:focus,
        &:active {
          outline: 0;
          color: lighten($secondary, 15%);
          svg {
            // fill: lighten($secondary, 15%);
            fill: lighten(black, 15%);
          }
        }
      }
    }
  }

  .slider {
    position: relative;
    width: #{100% / $tab-count};
    transition: all 0.33s cubic-bezier(0.38, 0.8, 0.32, 1.07);
    .indicator {
      position: relative;
      width: $indicator-width;
      max-width: 100%;
      margin: 0;
      height: $indicator-height;
      background: $accent;
      border-radius: 1px;
    }
  }

  .onboarding {
    text-align: left;
  }
  .content {
    margin-top: 30px;

    section {
      display: none;
      animation: {
        name: content;
        direction: normal;
        duration: 0.3s;
        timing-function: ease-in-out;
        iteration-count: 1;
      }
      line-height: 1.4;

      h2 {
        color: $accent;
        display: none;
        &::after {
          content: '';
          position: relative;
          display: block;
          width: 30px;
          height: 3px;
          background: $accent;
          margin-top: 5px;
          left: 1px;
        }
      }
    }
  }

  input[name='tab-control'] {
    @include tabs {
      > label {
        cursor: default;
        color: $accent;

        svg {
          fill: $accent;
        }

        @media (max-width: map-get($breakpoints, small)) {
          background: rgba(0, 0, 0, 0.08);
        }
      }
    }
  }

  @keyframes content {
    from {
      opacity: 0;
      transform: translateY(5%);
    }
    to {
      opacity: 1;
      transform: translateY(0%);
    }
  }

  @media (max-width: map-get($breakpoints, medium)) {
    ul li label {
      white-space: initial;

      br {
        display: initial;
      }

      svg {
        height: 1.5em;
      }
    }
  }

  @media (max-width: map-get($breakpoints, small)) {
    .tabs {
      width: 100% !important;
      height: 600px;
      padding: 10px !important;
    }
    ul li label {
      padding: 5px;
      border-radius: 5px;

      span {
        display: none;
      }
    }
    .uploadDetails {
      font-size: 1.1em;
    }

    .add-btn {
      width: 80%;
    }

    .slider {
      display: none;
    }

    .content {
      margin-top: 20px;
      section h2 {
        display: block;
        text-align: left;
      }
    }
    .about-img {
      padding: 0em;
      margin: 5px;
      vertical-align: top;
    }
    .about-text {
      display: inline-block;
      /* max-width: 400px; */
      text-align: left;
    }

    .about-text br {
      padding: 0px;
      margin: 0px;
    }

    .predgovor {
      font-size: 3vh;
      text-align: left;
      line-height: 1.3em;
    }
    .feature {
      font-size: 2vh;
    }
  }
}

.about-container {
  text-align: center;
}
.about-img {
  display: inline-block;
  max-width: 300px;
  text-align: left;
  vertical-align: top;
}
.about-img img {
  width: 100%;
}

.about-text {
  display: inline-block;
  max-width: 500px;
  text-align: left;
  margin-top: 5px;
  margin-left: 50px;
  padding: 5px;
  margin: 5px;
}

.feature {
  font-size: 3vh;
  text-align: left;
  line-height: 1.3em;
  color: $dark;
}

@media only screen and (max-width: 500px) {
  .tabs {
    // height: 950px;
  }
  .supplierDisclaimer {
    width: 90%;
    margin: 20px 10px;
    font-size: 0.8rem;
  }
}

@media only screen and (max-width: 350px) {
  .tabs ul li {
    padding: 0px;
  }
}

@media only screen and (min-width: 750px) {
  .faqStripe {
    width: 60%;
    margin: auto;
  }
}
</style>
